import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col } from '../../../../../../packages/kiti/components/structure/Grid'
import { useFormState } from '../../../../../../packages/kiti/components/form/form/FormHandler'
import EditableSentence from '../../EditableSentence'
import FormItem from '../../../../../../packages/kiti/components/form/form/FormItem'
import Modal from '../../../../../../components/structure/Modal'
import Separator from '../../../../../../packages/kiti/components/helpers/Separator'
import SlackChannelSelect from '../../../../../../containers/integrations/SlackChannelSelect'
import SubmitBar from '../../../../../../packages/kiti/components/form/SubmitBar'
import Text from '../../../../../../packages/kiti/components/presentation/Text'
import Textarea from '../../../../../../components/form/Textarea'
import InputWithInterpolations from '../../../../../../packages/kiti-editor/components/input/InputWithInterpolations'
import { useInterpolations } from '../../../../../../utils/interpolations/interpolations'
import { getGetSingleConditionValue } from '../../../_helpers/singleConditionValue'

const SlackSentence = () => {
  const [open, setOpen] = React.useState()
  const { form } = useFormState()
  const checklistId = getGetSingleConditionValue(form.conditions, 'checklist_id')
  const interpolations = useInterpolations(form.entity, checklistId)
  const interpolationGallery = interpolations.filter(i => i.type === 'gallery')

  return (
    <>
      <Text size="h2">para o canal:</Text>

      <EditableSentence
        label={form.payload?.channel?.name || '_______'}
        truncate={20}
        onClick={() => setOpen(true)}
        field="payload"
      />

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <Col width="100%">
          <FormItem
            label="Canal"
            path={['payload', 'channel']}
            Input={SlackChannelSelect}
            filter={{ integrationId: form.integrationId }}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem
            label="Anexos"
            path={['payload', 'attachments']}
            Input={InputWithInterpolations}
            interpolations={interpolationGallery}
          />
        </Col>

        <Separator weight={4} />

        <Col width="100%">
          <FormItem label="Mensagem" path={['payload', 'message']} Input={Textarea} />
        </Col>

        <SubmitBar onClick={() => setOpen(false)} />
      </Modal>
    </>
  )
}

export default SlackSentence
